import React from 'react';
import PropTypes from 'prop-types';

import CriteriumTable from '@hydra/common/criterium/CriteriumTable';
import Criterium from '@hydra/common/criterium/Criterium';

import { columns, createTableRow } from './tld_cybersquating_prevention';

export const TypoCybersquatingPrevention = ({ criterium }) => {
  const { data } = criterium;

  const body = data.map(createTableRow);
  const tableClasses = {
    body: ['', '', 'alignRight']
  };

  return (
    <Criterium criterium={criterium}>
      <CriteriumTable
        classNames={tableClasses}
        fixedColumns={[3, 5, 2]}
        head={columns}
        rows={body}
        thinHead
        striped
        nowrap
      />
    </Criterium>
  );
};

TypoCybersquatingPrevention.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        domain: PropTypes.string,
        isAvailable: PropTypes.bool,
        expiresAt: PropTypes.number
      })
    )
  })
};

export default React.memo(TypoCybersquatingPrevention);
